<template>
  <div>
    <el-container>
      <el-aside style="width: 200px;">
        <Menu activeName="3-1"></Menu>
      </el-aside>
      <el-main style="display: flex;flex: 1;padding: 0;flex-direction: row;height: 100vh;">
        <!-- 路线详情信息start -->
        <div
          style="position: fixed;left: 210px;top: 10px;bottom: 10px;z-index: 999;background-color: #ffffff;padding: 20px;border-radius: 12px;height: 90vh;">
          <div style="display: flex;flex-direction: column;width: 320px;height: 100%;">
            <el-page-header @back="backRouteList" :content="route.name" style="color:#3c9cff;"></el-page-header>
            <div class="number-details">
              <div class="number-item">
                <div class="number-num">{{ placeList.length }}</div>
                <div class="number-label">途经点</div>
              </div>
              <div class="number-item">
                <div class="number-num">{{ route.distance }}</div>
                <div class="number-label">路程</div>
              </div>
              <div class="number-item">
                <div class="number-num">{{ route.duration }}</div>
                <div class="number-label">时长</div>
              </div>
            </div>

            <el-divider content-position="center">路线地点列表</el-divider>

            <div style="margin-top: 10px;overflow:auto;" class="infinite-list-wrapper">
              <el-card class="box-card" :class="index == placeIndex ? 'active-card' : ''" shadow="hover"
                       v-for="(place, index) in placeList" v-bind:key="index">
                <div style="display: flex;flex-direction: column;" @click="showPlaceDetails(index)">
                <span v-if="place.sort > 0 && place.state === 0"
                      style="font-size: 15px;font-weight: 500;color: #333333;">{{
                    place.sort
                  }}、{{ place.name }}</span>
                  <span v-if="place.sort > 0 && place.state === 1"
                        style="font-size: 15px;font-weight: 500;color: #5ac725;">{{
                      place.name
                    }}(已完成)</span>
                  <span v-if="place.sort <= 0" style="font-size: 15px;font-weight: 500;color: #ff9900;">
                  {{ place.name }}(还未规划)
                </span>

                  <p style="font-size: 12px;color: #666666;margin-top: 1px;margin-bottom: 0;"><i
                    class="el-icon-location"></i>{{ place.address }}</p>
                  <div style="display: flex;flex-direction: row;font-size: 12px;color: #666666;margin-top: 3px;"
                       v-if="place.phone">
                    <span><i class="el-icon-phone"></i>{{ place.phone_name }}({{ place.phone }})</span>
                  </div>
                  <p style="font-size: 12px;color: #999999;margin-bottom: 0;" v-if="place.remarks">备注：
                    {{ place.remarks }}
                  </p>
                </div>
              </el-card>
            </div>
          </div>
        </div>
        <!-- 路线详情信息end -->


        <div style="flex: 1;height: 100vh;">
          <el-amap vid="map" @init="initMap" style="flex: 1;">
            <el-amap-control-geolocation :visible="true"></el-amap-control-geolocation>

            <template v-if="list.length > 0">
              <el-amap-marker :zIndex="98" v-for="(item, index) in list" :key="'place-' + index" :vid="item.location"
                              anchor="center" :position="[item.longitude, item.latitude]"
                              @mouseover="handleMouseOver(item.id)"
                              @mouseout="handleMouseLeave">
                <div style="display: flex;flex-direction: column;align-items: center;">
                  <div
                    style="font-size: 12px;color: #333;background-color: #fff;border-radius: 4px;border: 1px solid #2979ff;white-space: nowrap;padding:2px 4px;z-index: 98;">
                    {{ item.name }}
                  </div>
                  <div class="route-place-sort">
                    {{ item.sort }}
                  </div>
                </div>
              </el-amap-marker>
            </template>

            <el-amap-info-window v-if="list.length > 0" v-for="(item, index) in list" :key="'place-window-' + index"
                                 :closeWhenClickMap="true" :position="[item.longitude, item.latitude]" :autoMove="false"
                                 :offset="[0, -20]"
                                 anchor="bottom-center" :visible="item.id == mapConf.overPlaceId">
              <div style="display: flex;flex-direction: column;padding:4px;margin-top: 4px;">
                <div style="font-size: 16px;color: #333;font-weight: 500">{{ item.name }}</div>
                <div style="font-size: 14px;color: #666;margin-top: 4px;">{{ item.address }}</div>
                <div style="font-size: 14px;color: #666;">客户：{{ item.phone_name }} 电话：{{ item.phone }}</div>
              </div>
            </el-amap-info-window>

            <template v-if="polyline.path.length > 0">
              <el-amap-polyline :path="polyline.path" :editable="false" :strokeColor="polyline.strokeColor"
                                :strokeWeight="polyline.strokeWeight" strokeStyle='solid' lineJoin="round"
                                :showDir="true"
                                :strokeOpacity="1"></el-amap-polyline>
            </template>
          </el-amap>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import Menu from '@/components/Menu.vue'
import {GetRoutePlace, GetTeamRouteList, SetRouteUser, GetRouteMapDetails, DeleteRoute} from '../api/route.js'
import {GetTeamUser} from '../api/personnel.js'

export default {
  name: 'Route',
  components: {Menu},
  data () {
    return {
      route: {},
      total: 0,
      list: [],
      placeList: [],
      placeIndex: '',
      routePolyline: {},
      routeMarkers: [],
      polyline: {
        path: [],
        strokeWeight: 6,
        borderWeight: 1,
        strokeColor: '#2979ff'
      },
      mapConf: {
        center: [],
        zooms: [3, 19],
        mapStyle: 'normal',
        overPlaceId: 0
      },
    }
  },
  mounted () {
    this.loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    })
  },
  methods: {
    initMap (e) {
      this.map = e
      this.showRouteDetails()
    },
    handleMouseOver (id) {
      console.log(id)
      let that = this
      clearTimeout(this.hoverTimer)
      this.hoverTimer = setTimeout(function () {
        that.mapConf.overPlaceId = id
      }, 500)
    },
    handleMouseLeave () {
      this.mapConf.overPlaceId = 0
      clearTimeout(this.hoverTimer)
      this.$forceUpdate()
    },
    backRouteList () {
      this.$router.push({name: 'route-list'})
    },
    getTeamUser () {
      let that = this
      GetTeamUser().then(res => {
        if (res.code === 200) {
          this.userList = res.data.list
        }
      })
    },
    showRouteDetails () {
      let that = this
      this.placeList = []
      this.getRoutePlaceList(this.$route.params.id)
      GetRouteMapDetails({route_id: this.$route.params.id}).then(res => {
        if (res.code === 200) {
          setTimeout(() => {
            this.loading.close()
          }, 2000)
          this.route = res.data.details
          this.list = res.data.list
          let points = res.data.points
          let path = []
          for (let i = 0; i < points.length; i++) {
            path.push([points[i].longitude, points[i].latitude])
          }
          this.polyline.path = path
        } else {
          this.loading.close()
          this.$notify({
            type: 'error',
            message: res.message,
            duration: 1500,
            onClose () {
              that.backRouteList()
            }
          })
        }
      }).catch(err => {
        this.loading.close()
      })
    },
    getRoutePlaceList (id) {
      let that = this
      GetRoutePlace({route_id: id}).then(res => {
        if (res.code === 200) {
          that.placeList = res.data.list
        }
      })
    },
    showPlaceDetails (index) {
      this.placeIndex = index
      let info = this.placeList[index]
      this.map.setCenter(new AMap.LngLat(parseFloat(info.locations.longitude), parseFloat(info.locations.latitude)))
      this.map.setZoom(15)
    }
  }
}
</script>

<style>
.number-details {
  width: 92%;
  margin: 20px auto;
  padding: 12px;
  border-radius: 8px;
  box-shadow: 0 0 10px 0 rgba(127, 127, 128, 0.16);
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.number-details .number-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.number-item .number-num {
  font-size: 14px;
  color: #000;
  font-weight: bold;
}

.number-item .number-label {
  font-size: 12px;
  color: #808695;
  margin-top: 2px;
}

.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}

.active-card {
  background-color: #ecf5ff;
}

.route-place-sort {
  font-size: 12px;
  width: 20px;
  height: 20px;
  border-radius: 20px;
  text-align: center;
  line-height: 20px;
  color: #fff;
  border: 2px solid #fff;
  background-color: #2979ff;
  z-index: 99;
}
</style>



// WEBPACK FOOTER //
// src/views/Route.vue